import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import { getWebClient, getDataTablesLanguage } from '../helpers/Helpers.js';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';

export default function RiepilogoAppuntamentiSeller({ setAuthenticationToken }) {

    DataTable.use(DT);

    const columns = [
        { data: 'ragioneSociale' },
        { data: 'appuntamentiProposti' },
        { data: 'appuntamentiInCodaProposti' },
        { data: 'appuntamentiConfermati' },
        { data: 'appuntamentiInCodaConfermati' },
        { data: 'appuntamentiAnnullati' },
        { data: 'appuntamentiInCodaAnnullati' }
    ];

    const options = {
        language: getDataTablesLanguage()
    };

    const [tableData, setTableData] = useState([]);   

    useEffect(() => {

        const client = getWebClient();

        client.get(`/api/riepilogoappuntamentiseller`)
            .then(function (response) {
                setTableData(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

    }, []);

    return (
        <>

            <link href="https://cdn.datatables.net/v/bs5/dt-2.1.8/datatables.min.css" rel="stylesheet"></link>

            <Navbar setAdminAuthenticationToken={setAuthenticationToken} />

            <div className="container" style={{ marginTop: 40, marginBottom: 40 }} >
                <h4>Riepilogo appuntamenti seller</h4>
            </div>

            <div className="container">
                <DataTable data={tableData} columns={columns} options={options} className="table">
                    <thead>
                        <tr>
                            <th>Rsgione sociale</th>
                            <th>Proposti</th>
                            <th>Proposti in coda</th>
                            <th>Confermati</th>
                            <th>Confermati in coda</th>
                            <th>Annullati</th>
                            <th>Annullati in coda</th>
                        </tr>
                    </thead>
                </DataTable>
            </div>

        </>
    )
}
